import MetalGold from "../../images/metal-gold-card.png";
import MetalSilver from "../../images/metal-silver-card.png";
import MetalBlack from "../../images/metal_black.png";
import PlasticBlack from "../../images/plastic_black.png";
import VirtualCard from "../../images/virtual-card-image.png";

export const cardImages = {
  metal_silver: MetalSilver,
  metal_gold: MetalGold,
  metal_black: MetalBlack,
  plastic: PlasticBlack,
  virtual: VirtualCard,
};
export const cardRequestParams = (cardType, countryCode, values) => ({
  card_type: cardType,
  country_code: countryCode,
  occupation: values.occupation,
  first_name: values.first_name,
  middle_name: values.middle_name,
  last_name: values.last_name,
  phone_code: values.phone_code,
  phone_number: values.phone_number,
  name_on_card: values.name_on_card,
  date_of_birth: values.date_of_birth,
  annual_salary: values.annual_salary,
  account_purpose: values.account_purpose,
  expected_monthly_volume: values.expected_monthly_volume,
  address: values.address,
  city: values.city,
  state: values.state,
  country: values.country,
  postal_code: values.postal_code,
  passport_bio_page: values.passport_bio_page || null,
});

const personalAttributes = [
  "first_name",
  "middle_name",
  "last_name",
  "phone_code",
  "phone_number",
  "occupation",
  "name_on_card",
  "annual_salary",
  "account_purpose",
  "expected_monthly_volume",
  "date_of_birth",
  "passport_bio_page",
];

const mailingAttributes = [
  "address",
  "state",
  "city",
  "country",
  "postal_code",
];

export const formattedApiErrors = (errors) => {
  const errorKeys = [...personalAttributes, ...mailingAttributes];

  const apiErrors = {};

  errorKeys.forEach((key) => {
    apiErrors[`${key}_error`] = errors[key];
  });

  return apiErrors;
};

export const stepFromError = (errors) => {
  const attributes = errors.map((err) => err.attribute);

  if (attributes.some((attr) => personalAttributes.includes(attr))) {
    return "personal";
  }

  return "mailing";
};

export const stepFromVirtualFormError = (errors) => {
  const attributes = errors.map((err) => err.attribute);

  if (attributes.some((attr) => personalAttributes.includes(attr))) {
    return "personal";
  }

  return "mailing";
};
